var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slideout"}},[(_vm.open)?_c('div',{staticClass:"slideout"},[_c('div',{staticClass:"slideout-backdrop",on:{"click":function($event){return _vm.$emit('close')}}}),_vm._v(" "),_c(_vm.panelTag,{tag:"Component",class:_vm.panelClass ||
					'absolute top-0 right-0 flex h-full w-full flex-col overflow-hidden bg-white p-0 shadow-lg slideout-panel sm:w-[450px]'},[_vm._t("default")],2)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }